import { faClock, faFire, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllRecipes } from './api';
import Heading1 from './headings/Heading1';

function OurPicks() {
  const [recipes, setRecipes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllRecipes()
      .then((all) => {
        // Pick top recipes (by some criteria: high protein, low cal, or featured)
        const sorted = [...(all || [])].sort((a, b) => {
          // prioritize highProtein, then lower calories
          if (a.highProtein && !b.highProtein) return -1;
          if (!a.highProtein && b.highProtein) return 1;
          return (a.calories || 999) - (b.calories || 999);
        });
        setRecipes(sorted.slice(0, 5)); // take top 5
      })
      .catch((err) => console.error(err));
  }, []);

  if (!recipes || recipes.length === 0) return null;

  const handleClick = (id) => navigate(`/recipe/${id}`);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 space-y-6">
      <div className="text-left space-y-2">
        <Heading1 title="Our Picks" />
        <p className="text-gray-600">Curated recipes chosen just for you</p>
      </div>

      <div className="bento-grid">
        {recipes.map((recipe, idx) => {
          // Layout pattern: first item large, others smaller
          const isLarge = idx === 0;
          return (
            <div
              key={recipe.id}
              onClick={() => handleClick(recipe.id)}
              className={`bento-item ${isLarge ? 'bento-large' : 'bento-small'} group cursor-pointer`}
            >
              <div className="relative w-full h-full overflow-hidden rounded-2xl bg-gradient-to-br from-orange-50 via-white to-purple-50 border border-gray-100 shadow-sm hover:shadow-lg transition">
                <img
                  src={recipe.imageURL}
                  alt={recipe.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white space-y-2">
                  <h3 className={`font-semibold ${isLarge ? 'text-2xl' : 'text-lg'}`}>
                    {recipe.title}
                  </h3>
                  <div className="flex flex-wrap gap-2 text-xs">
                    {recipe.calories && (
                      <span className="inline-flex items-center gap-1 bg-white/20 backdrop-blur-sm px-2 py-1 rounded-full">
                        <FontAwesomeIcon icon={faFire} />
                        {recipe.calories} kcal
                      </span>
                    )}
                    {recipe.cookingMinutes && (
                      <span className="inline-flex items-center gap-1 bg-white/20 backdrop-blur-sm px-2 py-1 rounded-full">
                        <FontAwesomeIcon icon={faClock} />
                        {recipe.cookingMinutes} min
                      </span>
                    )}
                    {recipe.difficulty && (
                      <span className="inline-flex items-center gap-1 bg-white/20 backdrop-blur-sm px-2 py-1 rounded-full">
                        <FontAwesomeIcon icon={faUtensils} />
                        {recipe.difficulty}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OurPicks;
